module.exports = __webpack_public_path__ + "img/img_electric.57dcd03c.png";